import React, { useState, useEffect } from 'react';
import blankImage from '../assets/images/blank.png';

const Image = ({ src, alt, className, style, fallbackSrc, ...props }) => {
    const [imgSrc, setImgSrc] = useState(src);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (!src) {
            setImgSrc(fallbackSrc || blankImage);
            setIsLoading(false);
            setHasError(true);
        } else {
            setImgSrc(src);
            setIsLoading(true);
            setHasError(false);
        }
    }, [src, fallbackSrc]);

    const handleLoad = () => {
        setIsLoading(false);
    };

    const handleError = () => {
        if (!hasError) { // Prevent infinite loop if fallback also fails
            setHasError(true);
            setIsLoading(false);
            setImgSrc(fallbackSrc || blankImage);
        }
    };

    return (
       
            <img
                src={imgSrc}
                alt={alt || 'img'}
                onLoad={handleLoad}
                onError={handleError}
                style={style}
                className={className || ''}
                {...props}
            />
    );
};

export default Image;
